import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import ItemCard from "../components/ItemCard";
import ItemDetailDrawer from "../components/ItemDetailDrawer";
import api from "../lib/api";
import { Loader2 } from "lucide-react";

export default function ItemListPage({ titleKey, subtitleKey, testid, status, excludeCompleted }) {
  const { t } = useTranslation();
  const [items, setItems] = useState(null);
  const [selected, setSelected] = useState(null);

  const load = useCallback(() => {
    const params = status ? { status } : {};
    api.get("/items", { params }).then(({ data }) => {
      let out = data;
      if (excludeCompleted) out = data.filter((i) => i.status !== "completed" && i.status !== "archived");
      setItems(out);
    });
  }, [status, excludeCompleted]);

  useEffect(() => { load(); }, [load]);

  return (
    <Layout onDataChanged={load}>
      <div className="animate-fade-up" data-testid={testid}>
        <h1 className="text-2xl sm:text-3xl font-bold font-display tracking-tight">{t(titleKey)}</h1>
        <p className="text-muted-foreground mt-1 text-sm">{t(subtitleKey)}</p>
      </div>

      {!items ? (
        <div className="py-20 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
      ) : items.length === 0 ? (
        <p className="mt-12 text-center text-sm text-muted-foreground">{t("dashboard.listEmpty")}</p>
      ) : (
        <div className="mt-8 grid sm:grid-cols-2 gap-3">
          {items.map((item) => <ItemCard key={item.id} item={item} onClick={(it) => setSelected(it.id)} />)}
        </div>
      )}

      <ItemDetailDrawer itemId={selected} open={!!selected} onClose={() => setSelected(null)} onChanged={load} />
    </Layout>
  );
}
